import { useSelector } from "react-redux";
import { selectCurrentOffice } from "../features/auth/authSlice";

const useCurrentOffice = () => {
  const office = useSelector(selectCurrentOffice);

  return { office };
};
export default useCurrentOffice;
